module.exports = __webpack_public_path__ + "static/template180-97c888e1af4651a819898f3481a66be3.png";